import { Component, h, Prop } from '@stencil/core';
import '../../../stories/Components/Head/ClosedHeader/ClosedHead';
import { ConversationDetails } from '../../../types/ConversationDetailsTypes';

@Component({
  tag: 'chat-header-closed',
  shadow: true
})
export class ChatHeaderClosed {
  @Prop() conversationDetails: ConversationDetails;
  @Prop() onMinimize: () => void;
  @Prop() onClose: () => void;

  render() {
    return (
      <close-head
        profileImage={this.conversationDetails?.opponentDetails?.userProfileImageUrl || ''}
        text={this.conversationDetails?.opponentDetails?.userName}
        onFirstSvgClick={this.onMinimize}
        onSecondSvgClick={this.onClose}
        borderRadius="8px 8px 0 0"
        borderColor="#E6E8F3"
        borderStyle="solid"
        borderWidth="0px 0px 2px 0px"
        padding="20px 15px 20px 15px"
        conversationDetails={this.conversationDetails}
        bgColor={'var(--chat-header-bg)'}
        textColor={'var(--chat-header-text)'}
        nameTextColor= {'var(--chat-header-name-text)'}
        closeIconColor= {'var(--chat-header-close-icon)'}
        minimizeIconColor = {'var(--chat-header-minimize-icon)'}
      />
    );
  }
}

